import { http, lHttp } from '@utils/interceptor'
import { cookies, isHzwApp, uid } from '@utils/index'

const api = {
  getShareIncome: '//svsesapi.cekid.com/svses-api/shareMoney/getShareIncome.do', //个人收益统计
  getShareIncomeApp: '//svsesapi.cekid.com/svses-api/shareMoney/getShareIncomeApp.do', //个人收益统计
  queryAccount: '//scbapi.cekid.com/scb-api/user/queryAccount.do', //个人账户
  queryShareMoneyData: '//svsesapi.cekid.com/svses-api/shareMoney/queryShareMoneyData.do', //分销宝收益统计
  queryShareMoneyDataApp: '//svsesapi.cekid.com/svses-api/shareMoney/queryShareMoneyDataApp.do' //分销宝收益统计
}

export async function getShareIncome() {
  const skey = cookies.get('skey') || ''
  return http.get(isHzwApp() ? api.getShareIncomeApp : api.getShareIncome, {
    params: {
      uid,
      skey
    },
    withCredentials: true
  })
}

export async function getUserAccount() {
  const skey = cookies.get('skey') || ''
  return http.get(api.queryAccount, {
    params: {
      uid,
      skey
    }
  })
}

export async function getStoreIncomeList(params: any) {
  const skey = cookies.get('skey') || ''
  const apistr = isHzwApp() ? api.queryShareMoneyDataApp : api.queryShareMoneyData
  return lHttp.get(apistr, {
    params: {
      uid,
      skey,
      ...params
    },
    withCredentials: true
  })
  // return {
  //   errno: '0',
  //   errmsg: '132',
  //   data: {
  //     count: 10,
  //     total: 10,
  //     rows: [
  //       {
  //         title: '商品名称',
  //         cover_url: '',
  //         act_price: '20',
  //         order_time: '',
  //         mobile: '13222022140',
  //         item_state: '0',
  //         income: 20,
  //         recommend: 0.2,
  //         shop_name: '商家名称',
  //         sku_name: '规格'
  //       },
  //       {
  //         title: '商品名称',
  //         cover_url: '',
  //         act_price: '20',
  //         order_time: '',
  //         mobile: '13222022140',
  //         item_state: '0',
  //         income: 20,
  //         recommend: 0.2,
  //         shop_name: '商家名称',
  //         sku_name: '规格',
  //         time: {
  //           orderId: '123456', //订单号
  //           barcodeState: 0, // 核销码状态 1 已核销 0 未核销
  //           serviceTime: '2020-12-21', //预产期 2020-12-21
  //           workState: 40, // 上户状态 0 未申请上户 30 已申请上户 40 已确认上户
  //           confirmHouseholdTime: '2020-12-21', // 确认上户时间 2020-12-21
  //           writeoffTime: '2020-12-21 16:11:00' // 核销时间 2020-12-21 16:11:00
  //         },
  //         money: [
  //           {
  //             id: 2,
  //             order_id: 160678802494000000,
  //             type: 1,
  //             type_name: '下单付款',
  //             emp_rate: 0.02,
  //             saler_money: 2,
  //             status: 1,
  //             create_time: '2020-12-09 14:56:24',
  //             update_time: '2020-12-09 15:35:56'
  //           },
  //           {
  //             id: 3,
  //             order_id: 160678802494000000,
  //             type: 2,
  //             type_name: '回访记录',
  //             emp_rate: 0.01,
  //             saler_money: 1,
  //             status: 0,
  //             create_time: '2020-12-09 14:56:24',
  //             update_time: ''
  //           },
  //           {
  //             id: 4,
  //             order_id: 160678802494000000,
  //             type: 3,
  //             type_name: '订单评价',
  //             emp_rate: 0.01,
  //             saler_money: 1,
  //             status: 0,
  //             create_time: '2020-12-09 14:56:24',
  //             update_time: ''
  //           }
  //         ]
  //       }
  //     ]
  //   }
  // }
}
